import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import CouponButtonUi from './ui/coupon-button-ui'
import CouponDiscountUi from './ui/coupon-discount-ui'
import CouponErrorUi from './ui/coupon-error-ui'
import CouponFieldUi from './ui/coupon-field-ui'
import CouponUi from './ui/coupon-ui'
import CouponWrapperUi from './ui/coupon-wrapper-ui'

interface CouponProps
  extends Omit<
    CouponInterface,
    'couponError' | 'couponCode' | 'discount' | 'type' | 'id' | 'parentId'
  > {
  onCodeChange: (code: string) => void
  isChecking: boolean
  onCheck: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  couponError?: string
  couponCode: string
  discount?: ReactNode
}

export default function Coupon({
  button,
  onCodeChange,
  htmlAttrId,
  couponCode,
  discount,
  isChecking,
  onCheck,
  couponError,
  field,
}: CouponProps) {
  const { t } = useTranslation('common')
  return (
    <CouponWrapperUi htmlAttrId={htmlAttrId}>
      <React.Fragment>
        <CouponUi>
          <CouponFieldUi
            value={couponCode}
            onChange={e => onCodeChange(e.target.value)}
            placeholder={field.placeholder}
            fontSize={field.fontSize}
            mobileFontSize={field.mobileFontSize}
            color={field.color}
            mobileColor={field.mobileColor}
            backgroundColor={field.backgroundColor}
            mobileBackgroundColor={field.mobileBackgroundColor}
            border={field.border}
            mobileBorder={field.mobileBorder}
          />
          <CouponButtonUi
            checking={isChecking}
            onClick={e => {
              e.preventDefault()
              return onCheck(e)
            }}
            fontSize={button.fontSize}
            mobileFontSize={button.mobileFontSize}
            color={button.color}
            mobileColor={button.mobileColor}
            border={button.border}
            mobileBorder={button.mobileBorder}
            backgroundColor={button.backgroundColor}
            mobileBackgroundColor={button.mobileBackgroundColor}
          >
            {button.text}
          </CouponButtonUi>
        </CouponUi>
        {discount && (
          <CouponDiscountUi>
            {t('components.coupon.discount')} {discount}
          </CouponDiscountUi>
        )}
        {couponError && <CouponErrorUi>{couponError}</CouponErrorUi>}
      </React.Fragment>
    </CouponWrapperUi>
  )
}
